import stylesTheme from "../stylesTheme";

const chipStyles = {
  fontSize: stylesTheme.typography.pxToRem(14),
  fontWeight: 600,
};

export const MuiChip = {
  MuiChip: {
    root: {
      borderRadius: "4px",
      height: "30px",
      minWidth: "100px",
      backgroundColor: stylesTheme.palette.info.light,
      color: stylesTheme.palette.info.main,
      ...chipStyles,
    },
    colorPrimary: {
      backgroundColor: stylesTheme.palette.success.light,
      color: stylesTheme.palette.success.main,
      ...chipStyles,
    },
    colorSecondary: {
      backgroundColor: stylesTheme.palette.error.light,
      color: stylesTheme.palette.error.main,
      ...chipStyles,
    },
  },
};
